export default __webpack_public_path__ + "static/media/audio-test.f4628aa1.mp3";